import { DOCUMENT } from '@angular/common';
import { Injectable, RendererFactory2, inject } from '@angular/core';

declare var Razorpay: any;

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private _rendererFactory = inject(RendererFactory2);
  private _document: Document = inject(DOCUMENT);

  constructor() {}

  private _init() {
    const renderer = this._rendererFactory.createRenderer(null, null);
    let script = renderer.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    renderer.appendChild(this._document.head, script);
  }

  async processPayment(initPaymentInfo: any) {
    this._init();
    await this._delay(1000);
    const payload = initPaymentInfo?.sdk_payload?.payload;
    var rzp1 = new Razorpay(payload);
    rzp1.open(payload);
  }

  private _delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
